import { createRouter, createWebHistory } from "vue-router";
import { jwtDecode } from "jwt-decode";

const routeModules = require.context("./groups", true, /routes\.js$/);
const routes = [];

routeModules.keys().forEach((fileName) => {
  const routeModule = routeModules(fileName).default;
  routes.push(...routeModule);
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // Ambil token dari query parameter
  const token = to.query.token;
  const username = to.query.name;
  const storedUserData = localStorage.getItem("userData");
  let userLevel = [];

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > now) {
        const newUserData = {
          nama: username,
          token: token,
        };
        localStorage.setItem("userData", JSON.stringify(newUserData));

        userLevel = decodedToken.level || [];

        const lastRoute = localStorage.getItem("lastRoute") || "/dashboard";
        localStorage.removeItem("lastRoute");
        return next(lastRoute);
      }
    } catch (err) {
      console.error("Invalid token from query:", err);
    }
  }

  if (storedUserData) {
    try {
      const userAccess = JSON.parse(storedUserData);
      if (!userAccess.token) throw new Error("Token missing");

      const decodedToken = jwtDecode(userAccess.token);
      const now = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > now) {
        userLevel = decodedToken.role || [];
      } else {
        localStorage.removeItem("userData");
        return next("/login");
      }
    } catch (err) {
      console.error("Invalid token:", err);
      localStorage.removeItem("userData");
      return next("/login");
    }
  }

  const requiredLevel = to.meta.requiredLevel;

  if (
    to.path !== "/" &&
    to.path !== "/login" &&
    to.path !== "/update-email" &&
    to.path !== "/registrasi" &&
    to.path !== "/home" &&
    to.path !== "/privacy-policy" &&
    to.path !== "/disclaimer" &&
    to.path !== "/syarat-penggunaan" &&
    to.path !== "/lupa-password" &&
    !storedUserData
  ) {
    localStorage.setItem("lastRoute", to.fullPath);
    next("/login");
  } else if (to.path === "/login" && storedUserData) {
    if (userLevel == "user") {
      next("/profil");
    }
    const lastRoute = localStorage.getItem("lastRoute") || "/dashboard";
    localStorage.removeItem("lastRoute");
    next(lastRoute);
  } else if (
    requiredLevel &&
    ![].concat(requiredLevel).some((level) => userLevel.includes(level))
  ) {
    next("/forbidden");
  } else {
    next();
  }
});

export default router;
